import { Component } from '@angular/core';

@Component({
  selector: 'cd-temporary-downtime',
  templateUrl: './temporary-downtime.component.html',
  styleUrls: ['./temporary-downtime.component.scss'],
})
export class TemporaryDowntimeComponent {
}